import {
  NavigateOptions as INavigateOptions,
  useNavigate,
  useSearchParams,
} from 'react-router-dom'

export interface NavigateOptions extends INavigateOptions {
  keepParams?: boolean
  rmParams?: string[]
  chParam?: { key: string; newValue: string }[]
}

const useNavigateWithParams = () => {
  const [params] = useSearchParams()
  const _navigate = useNavigate()

  return (to: string, options?: NavigateOptions) => {
    const { keepParams = true, rmParams, chParam, ...rest } = options || {}
    if (rmParams) {
      for (const param of rmParams) {
        params.delete(param)
      }
    }
    if (chParam) {
      for (const param of chParam) {
        params.delete(param.key)
        params.set(param.key, param.newValue)
      }
    }
    _navigate(
      {
        pathname: to,
        search: keepParams ? params.toString() : undefined,
      },
      rest
    )
  }
}

export default useNavigateWithParams
